export const siteConstants = {
    GETALL_REQUEST: 'SITES_GETALL_REQUEST',
    GETALL_SUCCESS: 'SITES_GETALL_SUCCESS',
    GETALL_FAILURE: 'SITES_GETALL_FAILURE',

    UPDATE_REQUEST: 'SITES_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'SITES_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'SITES_UPDATE_FAILURE'
};
